import type { PagedResultDto } from "@services/dto/pagedResultDto"
import viewService from "@services/master-data/viewService"
import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class ViewStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable listData!: any
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.listData = []
  }

  @action
  async createOrUpdate(body: any) {
    const result = await viewService.createOrUpdate(body)
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
    appDataStore.GetListView()
  }

  @action
  async emptyDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await viewService.activate(id, isActive)
    appDataStore.GetListView()
  }

  @action
  async get(id: number) {
    const result = await viewService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await viewService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async getList(params: any) {
    this.isLoading = true
    const result = await viewService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listData = result
  }
}

export default ViewStore
